import {GridColumnWithContent, useDataGrid, UseDataGridResult} from "../DataGrid/useDataGrid";
import {EntityDataGridProps} from "./EntityDataGrid";

export type UseEntityDataGridProps<E> = Pick<EntityDataGridProps<E>, 'data' | 'colWidths' | 'sort'> & {
  colsMap: GridColumnWithContent<E>[]
}

export type UseEntityDataGridResult<E> = UseDataGridResult<E>

export function useEntityDataGrid<E>(props: UseEntityDataGridProps<E>): UseEntityDataGridResult<E> {
  const {data = [], colsMap, sort} = props;

  const dataGridArgs = useDataGrid<E>({
    colsMap: colsMap,
    data: data,
    sort: sort,
  });

  return {
    ...dataGridArgs,
  };
}
